/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-06-10 14:30:00
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-12 14:34:45
 */
import React, { useEffect } from 'react';
import useUploadErrorToastStore, { setUploadErrorToast } from '$/store/useUploadErrorToastStore';
import { createSmartcatTranslation } from '$/store/languageStore/smartcatTranslation';
import { useLanguageStore } from '$/store/languageStore';
import { replaceTemplateParams } from '$/utils';
import { message } from '../Message';

export default function UploadErrorToast() {
  const messageList = useUploadErrorToastStore((state) => state.messageList);
  const languageStore = useLanguageStore((state) => state.languageStore);

  useEffect(() => {
    if (messageList?.length) {
      const content = (
        <span>
          {messageList.map((msg) => {
            const template = languageStore.smartcatTranslationText(
              (v) => v[msg.message.key as keyof ReturnType<typeof createSmartcatTranslation>],
            );
            const template1 = languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_file_upload_fail);
            return (
              <span key={msg.message.key}>
                {replaceTemplateParams(template || msg.message.key, msg.message.params)}
                ：
                {msg.fileNum > 1 ? replaceTemplateParams(template1, {
                  num: msg.fileNum,
                }) : languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_file_upload_single_fail)}
                <br />
              </span>
            );
          })}
        </span>
      );

      message.info(content, 2, () => {
        setUploadErrorToast(false);
      });
    }
  }, [messageList, languageStore]);

  return null;
}
